import { useQuery, UseQueryOptions } from 'react-query';
import client from 'client';

export type TicketType = {
    id: number;
    email: string;
    virtualCheckin: boolean;
    personId: number;
    attendeeEmail?: string;
};

const fetchUserTickets = async (eventId: number) => {
    const response = await client().get<TicketType[]>(
        `/api/v2/userProfile/tickets?eventId=${eventId}`
    );
    return response.data;
};

export const useTickets = <TData = TicketType[]>(
    eventId: number,
    options?: UseQueryOptions<TicketType[], Error, TData>
) => {
    return useQuery(['tickets', eventId], () => fetchUserTickets(eventId), options);
};

export default useTickets;
